import { KYCLevelCard as UIKYCLevelCard, type KYCLevelCardProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

type Props = Omit<KYCLevelCardProps,
    | 'accountLevelLabel'
    | 'benefitsLabel'
    | 'upgradeButtonLabel'
    | 'coverBenefitsText'
    | 'coverComingSoonText'
    | 'coverStarsAltText'
>

const KYCLevelCard = (props: Props) => {
    const { t } = useTranslation()
    return (
        <UIKYCLevelCard
            {...props}
            accountLevelLabel={t('page.account.kycCard.accountLevel')}
            benefitsLabel={t('page.account.kycCard.benefits')}
            upgradeButtonLabel={t('page.account.kycCard.upgradeButton')}
            coverBenefitsText={t('page.account.kycCard.cover.benefits')}
            coverComingSoonText={t('page.account.kycCard.cover.comingSoon')}
            coverStarsAltText={t('page.account.kycCard.cover.starsAlt')}
        />
    )
}

export default KYCLevelCard
